import { Col } from 'antd';
import { Row } from 'antd';
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';
import CustomSearch from '../../../v2-components/Antd/Search';
import CustomTable from '../../../v2-components/Antd/Table';
import CustomTabs from '../../../v2-components/Antd/Tabs';
import { CustomNotification } from '../../../v2-components/Notification';
import { Service } from '../service';
import { generateColumns } from './handle/generate-columns.handle';
import { handleSearchParams } from './handle/search-params.handle';
import { tabOptions } from './handle/tabOptions.handle';
import './style.css';
import Loading from '../../../v2-components/Loading';
import { useTranslation } from 'react-i18next';

export default function ReserveListPage() {
	const [data, setData] = useState();
	const { t } = useTranslation('global');
	const [paginationResponse, setPaginationResponse] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location?.search);
	const page = searchParams.get('page');
	const statusQueryParam = searchParams.get('status');
	const rutQueryParam = searchParams.get('rut');
	const [status, setStatus] = useState(statusQueryParam);
	const [rut, setRut] = useState(rutQueryParam);
	const [rutSearchText, setRutSearchText] = useState('');
	const [orderSearchText, setOrderSearchText] = useState('');
	const { pharmacy } = GetLocalStorageValue(LOCAL_STORAGE.USER);
	const rowKey = '_id';

	useEffect(() => {
		new Service().getReserves({ status, page, pharmacy, rut }).then((response) => {
			setData(response.data);
			setPaginationResponse(response);
			setIsLoading(false);
		});
	}, [status, page, pharmacy, rut]);

	console.log('data',data)

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleStatusQueryChange = (status) => {
		searchParams.set('status', status);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleRutChange = (rut) => {
		searchParams.set('rut', rut);
		setRut(rut);
		if (!rut) {
			searchParams.delete('rut');
			setRut(null);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleOperationIdChange = (trxId) => {
		new Service().getReserveByTrxId(trxId).then((response) => {
			if (response !== undefined && response.country === Enviroment.LANGUAGE) {
				history.push(`/v2/reserve/detail/${trxId}`);
			} else {
				CustomNotification({
					type: 'warning',
					message: null,
					description: `No se encontro ninguna reserva con el numero de reserva: ${trxId}`,
				});
				return;
			}
		});
	};

	const handleSearchRut = (e) => {
		setRutSearchText(e.target.value);
	};

	const handleSearchOrder = (e) => {
		setOrderSearchText(e.target.value);
	};

	const onTabChange = () => {
		searchParams.set('page', 1);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleTabClick = (key) => {
		const tab = tabOptions(data).find((tab) => tab.key === key);
		if (tab) {
			setStatus(tab.status);
			handleStatusQueryChange(tab.status);
			onTabChange();
		}
		const filteredData = tabOptions(data).map((tab) => ({
			...tab,
			data: tab.data?.filter((item) => {
				return item;
			}),
		}));
		return filteredData;
	};

	const operations = (
		<div className="own-reserve-search-container">
			<CustomSearch placeholder={`N° de ${t('tracking.personalId').toUpperCase()}`} onChange={handleSearchRut} onSearch={() => handleRutChange(rutSearchText)} />
			<CustomSearch placeholder={'N° de solicitud'} onChange={handleSearchOrder} onSearch={() => handleOperationIdChange(orderSearchText)} />
		</div>
	);

	const paginationConfig = {
		current: paginationResponse?.currentPage,
		pageSize: paginationResponse?.itemsPerPage,
		total: paginationResponse?.totalItems,
		showSizeChanger: false,
		onChange: (page) => handlePageChange(page),
	};

	const initialActiveTab = tabOptions(data).find((tab) => tab.status === status)?.key;

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className='reserve-list-container'>
			<Row>
				<Col span={8}>
					<h2>Solicitudes</h2>
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<Col className={'own-main-container'}>
						<CustomTabs tabBarExtraContent={operations} onChange={handleTabClick} activeKey={initialActiveTab}>
							{handleTabClick().map((tab) => (
								<CustomTabs key={tab.key} tab={tab.tab}>
									<CustomTable dataSource={tab.data} columns={generateColumns()} pagination={paginationConfig} rowKey={rowKey} />
								</CustomTabs>
							))}
						</CustomTabs>
					</Col>
				</Col>
			</Row>
		</div>
	);
}
